import { ArrowUpRight } from "lucide-react";
import { LIVE_COUNTERS, LIVE_IMG, PIZZA_IMG, waLink } from "@/data/site";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const LiveCounters = () => (
  <section id="live-counters" data-testid="live-counters-section" className="bg-beige/40 py-24 md:py-36">
    <div className="max-w-7xl mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-14 lg:gap-24 items-start">
      <div>
        <SectionHeading chapter="06" eyebrow="Live Counters" title="Make Your Celebration" script="interactive." />
        <div className="mt-12 space-y-0 divide-y divide-espresso/10 border-y border-espresso/10">
          {LIVE_COUNTERS.map((c, i) => (
            <Reveal key={c.name} delay={i * 0.05} y={20}>
              <div data-testid={`counter-${c.name.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="group py-5 flex items-baseline gap-5 hover:pl-3 transition-all duration-500">
                <span className="font-serif text-gold-dark text-lg shrink-0">{String(i + 1).padStart(2, "0")}</span>
                <div>
                  <h3 className="font-serif text-xl md:text-2xl text-espresso group-hover:text-gold-dark transition-colors duration-300">{c.name}</h3>
                  <p className="text-espresso/55 text-sm font-light mt-1">{c.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <a
            data-testid="explore-counters-btn"
            href={waLink("Hi Momay Caterers, I'd love to explore live counters for my event. What options do you offer?")}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-10 inline-flex items-center gap-3 bg-espresso text-cream px-8 py-4 text-xs tracking-[0.25em] uppercase hover:bg-gold hover:text-espresso transition-colors duration-300"
          >
            Explore Live Counters <ArrowUpRight size={15} />
          </a>
        </Reveal>
      </div>

      <div className="lg:sticky lg:top-28 space-y-6">
        <Reveal>
          <div className="relative overflow-hidden">
            <div className="absolute -top-3 -right-3 w-full h-full border border-gold/40 pointer-events-none" />
            <img src={LIVE_IMG} alt="Chef preparing food at a live catering counter" loading="lazy" className="w-full aspect-[4/5] object-cover hover:scale-105 transition-transform duration-[1.2s]" />
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <img src={PIZZA_IMG} alt="Live pizza counter at an event" loading="lazy" className="w-2/3 ml-auto aspect-[4/3] object-cover shadow-2xl hover:scale-[1.03] transition-transform duration-700" />
        </Reveal>
      </div>
    </div>
  </section>
);
